@if (isMobileMQ) {
    <div class="tabs has-text-centered" data-tabs-context>
        <div class="tab-list">
            <button
                [attr.aria-selected]="currentTab === tabChoices.STORES ? 'true' : 'false'"
                data-tab-navigation
                class="tab {{ currentTab === tabChoices.STORES ? 'is-active' : '' }}"
                (click)="changeTab(tabChoices.STORES)"
                role="tab"
            >
                Liste
            </button>
            @if (stores?.length) {
                <button
                    [attr.aria-selected]="currentTab === tabChoices.MAP ? 'true' : 'false'"
                    data-tab-navigation
                    class="tab {{ currentTab === tabChoices.MAP ? 'is-active' : '' }}"
                    (click)="changeTab(tabChoices.MAP)"
                    role="tab"
                >
                    Carte
                </button>
            }
        </div>
    </div>
}
<div class="box is-paddingless">
    <div class="columns is-marginless is-mobile">
        <div
            [ngClass]="{ 'is-hidden': isMobileMQ && currentTab !== tabChoices.STORES }"
            class="column is-6-tablet is-paddingless is-narrow-tablet"
        >
            <div class="box is-shadowless is-marginless">
                <p class="text is-level-1" [ngPlural]="stores?.length">
                    <ng-template ngPluralCase="=0">
                        <p>Aucun magasin n’est disponible à l’adresse indiquée.</p>
                        <p>Vous pouvez modifier l’adresse ou sélectionner un autre mode de livraison.</p>
                    </ng-template>
                    <ng-template ngPluralCase="=1">Le {{ storeTitle }} le plus proches de&nbsp;:</ng-template>
                    <ng-template ngPluralCase="other">
                        Les
                        <span class="has-text-weight-semibold">
                            {{ stores?.length }}
                        </span>
                        {{ storeTitle }} les plus proches de&nbsp;:
                    </ng-template>
                </p>
                <div class="is-flex-widescreen is-aligned-center">
                    <p checkoutCsMask class="has-text-info text is-level-2 is-lowercase">
                        <span class="icon is-small">
                            <i class="tri-marker-solid" aria-hidden="true"></i>
                        </span>
                        {{ inlineAddress }}
                    </p>
                </div>
                <a (click)="changeAddressEvent($event)" class="link">Modifier l'adresse</a>
            </div>
            <div class="divider is-marginless"></div>
            @if (stores.length) {
                <div class="stores-container" checkoutCy="stores-container">
                    @for (store of stores; track store; let last = $last) {
                        <checkout-store
                            (selectStoreEvent)="handleSelectedStore($event)"
                            [isLast]="last"
                            [store]="store"
                            [isSelected]="store && store.id === currentStore?.id"
                            [id]="'store-' + store.id"
                            [shouldAvoidScrollDelay]="shouldAvoidScrollDelay"
                        ></checkout-store>
                    }
                </div>
            }
        </div>
        <div
            [ngClass]="{ 'is-hidden': isMobileMQ && currentTab !== tabChoices.MAP }"
            class="column is-paddingless map-tab"
        >
            @if (stores.length) {
                <checkout-gmaps
                    (markerSelectedEvent)="handleSelectedMarker($event)"
                    [markers]="markers"
                    [mapConfig]="mapConfig"
                    [isLoading]="!stores.length"
                    [updatePosition]="currentMarker"
                ></checkout-gmaps>
            }
            @if (isMobileMQ && currentStore && displayStoreModal) {
                <div class="box selected-store">
                    @if (isMobileMQ) {
                        <p>
                            <span (click)="hideModal()" class="close-selected-store icon is-small">
                                <i class="tri-times" aria-hidden="true"></i>
                            </span>
                        </p>
                    }
                    <checkout-store
                        [isStandAlone]="true"
                        [isLast]="true"
                        [store]="currentStore"
                        [isSelected]="false"
                        [shouldAvoidScrollDelay]="shouldAvoidScrollDelay"
                    ></checkout-store>
                </div>
            }
        </div>
    </div>
</div>
